// extracted by mini-css-extract-plugin
export default {"referral-widget":"Qr","referral-page":"Rr","label":"Sr","subHed":"Tr","profile-container":"Ur","referral-container":"Vr","referral-header":"Wr","shareMethodRow":"Xr","shareMethod":"Yr","active":"Zr","referral-stat":"as","blockwrapper":"bs","referralLink":"cs","bold":"es","semibold":"fs","shareAgainButton":"gs","policy":"hs","narrowWrapper":"is"};
    if(module.hot) {
      // 1738836192614
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  